import { render } from "./ImagePreviewModal.vue?vue&type=template&id=58b78150&scoped=true"
import script from "./ImagePreviewModal.vue?vue&type=script&lang=js"
export * from "./ImagePreviewModal.vue?vue&type=script&lang=js"

import "./ImagePreviewModal.vue?vue&type=style&index=0&id=58b78150&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58b78150"]])

export default __exports__